import { configureStore } from "@reduxjs/toolkit";
import controllerReducer from "./features/controllerRedux";

const store = configureStore({
    reducer: {
        controller: controllerReducer, // ✅ use slice reducer
    },
});

export default store;
